import Metric, { NumericType } from 'src/shared/models/metric';
import MetricData from 'src/shared/models/metric-data';
import { UIGridTableState } from "src/shared/models/ag-grid-helper.models";
import ModuleDataGroupItem from "src/shared/models/module-data-group-item";
import { TimeInterval } from "src/shared/models/module-manager/module-manager-settings.models";


// Strings used in moduleManager.addState()
export enum IntervalState {
    Chart = "chartState",
    ModuleDisplay = "intervalComboState",
    Table = "tableState",
    TotalsRow = "footerVisible",
    ParentVisible = "locationVisible"
}

// Strings of the different ModuleDisplays
export enum IntervalModuleDisplay {
    Dual = "dual",
    Chart = "chart",
    Table = "table",
    None  = "",
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs: this is IntervalModule.ModuleData
export interface IntervalModuleData {
    IncompatibleSettings: boolean;
    TooMuchData: boolean;
    DateRangeTooWideIntraday: boolean;

    IntervalTotals: { [interval: string]: TotalItem };
    AverageTotals: { [interval: string]: TotalItem };
    GroupTotals: { [groupID: number]: GroupTotalItem };
    Totals: { [metricID: number]: MetricData };
    Averages: { [metricID: number]: MetricData };
    BreakdownItems?: BreakdownItem[];
    SingleMetricItems?: SingleMetricItem[];
    GraphItems: GraphItem[];
    IntervalOrder: string[];
    Metrics: Metric[];
    ParentGroupName: string;
    ViewMode: TableViewMode;
    ListByInterval: boolean;
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export const enum TableViewMode {
    MultipleMetrics = 0,
    SingleMetric = 1,
    Breakdown = 2,
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export interface BreakdownItem {
    Interval: string;
    IntervalValue: string;
    GroupData: ModuleDataGroupItem;
    AllMetricData: { [metricID: number]: MetricData };
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export interface SingleMetricItem {
    GroupData: ModuleDataGroupItem;
    ParentGroupData: ModuleDataGroupItem;
    AllMetricData: { [interval: string]: MetricData };
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export interface TotalItem {
    Interval: string;
    IntervalValue: Date;
    AllMetricData: { [metricID: number]: MetricData };
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export interface GroupTotalItem {
    GroupID: string;
    GroupName: Date;
    AllMetricData: { [metricID: number]: MetricData };
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
// note: graph item is referring to the ChartJS not AgGrid
export interface GraphItem {
    MetricName: string;
    MetricCustomName: string;
    MetricID: number;
    NumericType: NumericType;
    NumericTypeName: string;
    MetricValues: number[];
    MetricDisplayValues: string[];
    IntervalType: TimeInterval;
    IntervalGroups: string[];
    IntervalGroupsRaw: string[];
    GroupNames: string[];
    GroupIds: number[];
}

// ClearView WebPortal/AppCode/Api/Controllers/Dashboard/IntervalController.cs
export interface IntervalTableState {
    stateKey: string;
    state: UIGridTableState;
}

// The type of data contained in the totals row.
export interface PinnedRowData {
    [key: number]: MetricData;
    [key: string]: MetricData;
}

